import { CSSValue } from 'library/ts/ui/enums/css/CSSValue';
export class LoadingAnimationSpinner {
    #enabled;
    #svg;
    #container;
    #cssAnimationClass;
    #jsRotationIntervalId;
    #utils;
    constructor(svg, container, cssAnimationClass = 'smart-tag-loading-animation') {
        this.#enabled = true;
        this.#utils = window.PARA.PlayerServices.Utilities;
        this.#svg = svg;
        this.#container = container;
        this.#cssAnimationClass = cssAnimationClass;
        this.#utils.CSS.injectCSS(this.#getSpinnerCSS());
        this.#create();
    }
    get name() {
        return 'LoadingAnimationSpinner';
    }
    get enabled() {
        return this.#enabled;
    }
    enable = () => {
        this.#enabled = true;
    };
    disable = () => {
        this.#enabled = false;
        this.hide();
    };
    startRotationJS = () => {
        const svg = this.svgElement();
        if (this.#utils.Type.isElement(svg) === false) {
            this.stopRotationJS();
            return;
        }
        this.#jsRotationIntervalId = setInterval(() => {
            if (this.#utils.Type.isElement(svg)) {
                let rotation = this.#utils.DOM.getElementRotation(svg);
                rotation = rotation + 2;
                svg.style.WebkitTransform = 'rotate(' + rotation + 'deg)';
                svg.style.msTransform = 'rotate(' + rotation + 'deg)';
                svg.style.transform = 'rotate(' + rotation + 'deg)';
            }
        }, 6);
    };
    stopRotationJS = () => {
        clearInterval(this.#jsRotationIntervalId);
        this.#jsRotationIntervalId = undefined;
    };
    startRotationCSS = () => {
        const svg = this.svgElement();
        if (this.#utils.Type.isElement(svg) === false)
            return;
        if (this.#utils.CSS.hasClass(svg, this.#cssAnimationClass) === false) {
            this.#utils.CSS.addClass(svg, this.#cssAnimationClass);
        }
    };
    pauseRotationCSS = () => {
        const element = this.svgElement();
        if (this.#utils.Type.isElement(element) === false)
            return;
        if (this.#utils.CSS.hasClass(element, this.#cssAnimationClass))
            this.#utils.CSS.removeClass(element, this.#cssAnimationClass);
    };
    show = (useInlineCSS = true) => {
        if (!this.#enabled) {
            return;
        }
        if (useInlineCSS === true) {
            this.#container?.style?.setProperty('opacity', '1', CSSValue.IMPORTANT);
        }
        const element = this.svgElement();
        if (this.#utils.Type.isElement(element) && !this.#utils.Type.isEmptyString(this.#cssAnimationClass) && this.#utils.Type.isString(this.#cssAnimationClass)) {
            this.startRotationCSS();
        }
    };
    hide = (useInlineCSS = true) => {
        if (useInlineCSS === true) {
            this.stop();
            this.#container?.style?.setProperty('opacity', '0', CSSValue.IMPORTANT);
        }
    };
    stop = () => {
        this.stopRotationJS();
        this.pauseRotationCSS();
    };
    svgElement = () => {
        return this.#container?.getElementsByTagName('svg')[0];
    };
    #create = () => {
        if (this.#utils.Type.isUndefined(this.#container) || this.#utils.Type.isUndefined(this.#svg))
            return;
        if (this.#utils.Type.isElement(this.#container)) {
            this.#container.innerHTML = this.#svg;
            this.stopRotationJS();
            this.pauseRotationCSS();
        }
    };
    #getSpinnerCSS = () => {
        const prefixes = ['-webkit-', '-khtml-', '-moz-', '-ms-', '-o-', ''];
        let classAnimation = '.' + this.#cssAnimationClass + ' {ANIMATION}';
        let classAnimationContent = '';
        let keyFrames = '';
        for (let i = 0; i < prefixes.length; i++) {
            classAnimationContent += (prefixes[i] + 'animation: smart-tag-loader-spin 1.4s linear 0s infinite;');
            keyFrames += ('\n' + '@' + prefixes[i] + 'keyframes smart-tag-loader-spin {' + '0% { transform: rotate(0deg); will-change: transform; } 100% { transform: rotate(360deg); will-change: transform; } }');
        }
        classAnimation = (classAnimation.replace('ANIMATION', classAnimationContent) + '\n');
        return (classAnimation + keyFrames);
    };
}
